"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.variantHasActionRequired = void 0;
const getOrderLineCompletionStatus_1 = require("./getOrderLineCompletionStatus");
const variantHasActionRequired = (variant) => {
    if (!variant)
        return false;
    if (!variant.order_lines)
        return false;
    return variant.order_lines.some((line) => !(0, getOrderLineCompletionStatus_1.getOrderLineCompletionStatus)(line));
};
exports.variantHasActionRequired = variantHasActionRequired;
